import * as React from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

const buttonKinds = {
  primary: "primary",
  secondary: "secondary",
};

const sizes = {
  s: "s",
  m: "m",
};

const Button = ({
  children,
  href,
  isActive = true,
  className = "",
  kind = buttonKinds.primary,
  size = sizes.m,
  onClick,
}) => {
  const buttonClass = classNames(styles.button, className, {
    [styles[`button_${size}`]]: size,
    [styles[`button_${kind}`]]: kind,
  });

  const Tag = href === "" ? "button" : "a";

  return (
    <Tag
      className={buttonClass}
      disabled={!isActive}
      onClick={onClick && onClick}
      href={href !== "" ? href : undefined}
    >
      {isActive ? children : <span className={styles.loader}>Loading</span>}
    </Tag>
  );
};

export default Button;
